import { useState } from 'react'

const FAQS = [
    {
        question: 'Can we white-label this for our clients?',
        answer: 'Yes. Most agencies present the work as their own. We stay behind the scenes, and proofs and reporting are built for you to pass along to your client.',
    },
    {
        question: 'How does pricing work for agencies?',
        answer: 'We quote you per campaign based on audience size, format, and postage, and you set your own client-facing price. There is no fixed minimum spend, but this is built for recurring campaigns rather than a single drop.',
    },
    {
        question: 'How fast can you get mail out?',
        answer: 'We offer 2-business-day production for most formats once creative and lists are approved, so a campaign moves as fast as your client approvals allow.',
    },
    {
        question: 'Do we need to bring the list and the creative?',
        answer: 'No. Bring either, both, or neither. We can source targeted lists and write and design the piece, or print and mail files you already have.',
    },
]

function PlusIcon({ className }) {
    return (
        <svg
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round">
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
    )
}

export default function FAQ() {
    const [openIndex, setOpenIndex] = useState(null)

    return (
        <section className="bg-white">
            <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 lg:py-16">
                <div className="flex flex-col gap-4 max-w-3xl mb-10">
                    <span className="text-secondary text-xs uppercase tracking-widest font-semibold">
                        Frequently asked
                    </span>
                    <h2
                        className="text-[#3F454F] tracking-tight text-3xl md:text-[44px] font-bold"
                        style={{ lineHeight: 1.05 }}>
                        Questions agencies ask first.
                    </h2>
                </div>

                <div className="flex flex-col gap-3">
                    {FAQS.map((faq, i) => (
                        <div
                            key={i}
                            className="flex flex-col bg-white rounded-2xl border border-secondary/30">
                            <button
                                type="button"
                                onClick={() =>
                                    setOpenIndex(openIndex === i ? null : i)
                                }
                                className="cursor-pointer flex flex-row items-center justify-between gap-4 px-6 py-5 text-left w-full hover:bg-secondary/[0.03] transition-colors rounded-2xl">
                                <span
                                    className="text-[#3F454F] font-semibold text-lg"
                                    style={{ lineHeight: '28px' }}>
                                    {faq.question}
                                </span>
                                <div className="w-8 h-8 shrink-0 rounded-full bg-secondary/10 flex items-center justify-center">
                                    <PlusIcon
                                        className={`w-4 h-4 text-secondary transition-transform duration-200 ${
                                            openIndex === i ? 'rotate-45' : ''
                                        }`}
                                    />
                                </div>
                            </button>
                            <div
                                className="overflow-hidden transition-all duration-300"
                                style={{
                                    maxHeight: openIndex === i ? '500px' : '0',
                                    opacity: openIndex === i ? 1 : 0,
                                }}>
                                <div
                                    className="px-6 pb-6 text-[#3F454F]/70 text-lg"
                                    style={{ lineHeight: '28px' }}>
                                    {faq.answer}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
